<template>
  <b-alert
    v-if="apiError"
    :show="Boolean(apiError)"
    variant="danger"
  >
    {{ apiError.message || apiError.code || apiError }}
    <ul
      v-if="apiError.data && apiError.data.errors"
      class="mb-0"
    >
      <li
        v-for="error in apiError.data.errors"
        :key="error"
      >
        {{ error }}
      </li>
    </ul>
    <div
      v-if="apiError.data && !apiError.data.errors"
      class="mt-1"
    >
      {{ apiError.data }}
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'APIError',
  props: {
    apiError: Error
  }
}
</script>
